import request from '@/utils/request'

/**
 * 获取财务记录列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getFinanceList(params) {
  return request({
    url: '/admin/finance/list',
    method: 'get',
    params
  })
}

/**
 * 获取财务记录详情
 * @param {Number} id 记录ID
 * @returns {Promise}
 */
export function getFinanceDetail(id) {
  return request({
    url: `/admin/finance/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取财务统计数据
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getFinanceStatistics(params) {
  return request({
    url: '/admin/finance/statistics',
    method: 'get',
    params
  })
}

/**
 * 导出财务数据
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function exportFinanceData(params) {
  return request({
    url: '/admin/finance/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 获取当前商家每日统计数据（分页）
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getMerchantDayStats(params) {
  return request({
    url: '/admin/merchant/day-stats/current/daily',
    method: 'get',
    params
  })
}
